import { $axios, apiList } from '@/api'

export default {
    state: () => ({
        userMessages: {
            messages: [],
            warnings: []
        },
        notification: [],
    }),

    mutations: {
        setUserMessages(state, payload) {
            state.userMessages = payload
        },
        setNotifications(state, payload) {
            state.notification = payload
        }
    },

    actions: {
        getUserMessages({commit, dispatch}, payload) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.notification.getUserMessages.method,
                    params: {
                        wsfunction: apiList.notification.getUserMessages.moodle_method,
                        useridto: payload.userId
                    }
                })
                    .then(resp => {
                        resolve(resp.data)
                        commit('setUserMessages', resp.data)
                        // dispatch('getNotification')
                    }).catch(err => reject(err))
            })
        },

        getNotification({commit, rootGetters}) {
            if (rootGetters.user.preferences.auth_forcepasswordchange) {
                return
            }

            $axios({
                method: apiList.notification.getPopupNotifications.method,
                params: {
                    wsfunction: apiList.notification.getPopupNotifications.moodle_method,
                    useridto: 0
                }
            }).then(resp => {
                commit('setNotifications', resp.data)
            }).catch(err => console.log(err))
        },
        readAllNotifications(_, payload) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.notification.readAllNotifications.method,
                    params: {
                        wsfunction: apiList.notification.readAllNotifications.moodle_method,
                    },
                    data: {
                        useridto: payload
                    }
                })
                    .then(resp => {
                        resolve(resp.data)
                    }).catch(err => reject(err))
            })
        }
    },

    getters: {
        notifications: (state) => state.notification
    }
}
